import securedAxios from '~/javascript/utils/axios'

const axios = securedAxios()

export function getSocialMonitors(businessId) {
  return axios.get(`/ajax/businesses/${businessId}/social_monitors`)
}
export function createSocialMonitor(businessId, data) {
  return axios.post(`/ajax/businesses/${businessId}/social_monitors`, data)
}
export function updateSocialMonitor(id, data) {
  return axios.patch(`/ajax/social_monitors/${id}`, data)
}
export function destroySocialMonitor(id) {
  return axios.delete(`/ajax/social_monitors/${id}`)
}
export function suggestTopics(businessId, params = {}) {
  return axios.post(`/ajax/businesses/${businessId}/social_monitors/suggest_topics`, params)
}
export function runMonitorNow(id) {
  return axios.post(`/ajax/social_monitors/${id}/run_now`)
}
export function getFindings(businessId, params = {}) {
  return axios.get(`/ajax/businesses/${businessId}/social_findings`, { params })
}
export function updateFinding(id, data) {
  return axios.patch(`/ajax/social_monitor_findings/${id}`, data)
}
